import React from "react";
import { useSelector } from "react-redux";
import { Button, Col, Form, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";

function MetafieldsPopup({ toggle, setToggle }) {
  const optionsData = useSelector((state) => state.PImAttributes.newOption);
  const [checkedState, setCheckedState] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [formValues, setFormValues] = useState({});

  useEffect(() => {
    const initialState = {};
    Object.keys(optionsData).forEach((key) => {
      initialState[key] = false; // default checked
    });
    setCheckedState(initialState);
  }, [optionsData]);

  const handleCheckboxChange = (key) => {
    setCheckedState((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));

    // If unchecking → reset dropdown values
    if (checkedState[key] === true) {
      setFormValues((prev) => ({
        ...prev,
        [key]: { dropdown1: "", dropdown2: "" },
      }));
    }
  };

  const handleDropdownChange = (key, field, value) => {
    setFormValues((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
  };
  return (
    <>
      <div >
      <Modal
        show={toggle}
        onHide={() => setToggle(false)}
        // aria-labelledby="example-custom-modal-styling-title"
        // dialogClassName="modal-90w"
        fullscreen={true}
        centered
        
      >
        <div className="bg-white p-6 rounded-lg shadow-lg p-5 rounded-3"  style={{overflowY:"scroll"}}>
          {/* <div style={{ display: "flex", justifyContent: "space-between" }}> */}
          <Modal.Header closeButton>
            <h5 className="fw-bold" style={{ textAlign: "b" }}>
              Metafields
            </h5>
          </Modal.Header>
          {/* </div> */}
          <input
            type="text"
            placeholder="Search by label or type"
            className="form-control mb-3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Row className="mappingInput">
            <Col sm={1}>
              <p>
                <strong></strong>
              </p>
            </Col>
            <Col sm={2}>
              <p>
                <strong>Label</strong>
              </p>
            </Col>
            <Col sm={2} className="">
              <p>
                <strong>Type</strong>
              </p>
            </Col>
            <Col sm={3} className="">
              <p>
                <strong>Existing Shopify product metafield (optional)</strong>
              </p>
            </Col>
            <Col sm={3} className="">
              <p>
                <strong>Existing Shopify variant metafield (optional)</strong>
              </p>
            </Col>
          </Row>
          {Object.entries(optionsData)
            .filter(([key, value]) => {
              const lower = searchTerm.toLowerCase();
              return (
                key.toLowerCase().includes(lower) ||
                value.toLowerCase().includes(lower)
              );
            })
            .map(([key, value], index) => (
              <React.Fragment key={index}>
                <Row className="mappingInput mb-2">
                  {/* Checkbox */}
                  <Col sm={1}>
                    <input
                      type="checkbox"
                      checked={checkedState[key] ?? true}
                      onChange={() => handleCheckboxChange(key)}
                    />
                  </Col>

                  {/* Key */}
                  <Col sm={2}>
                    <Form.Group>
                      <Form.Control type="text" value={key} readOnly />
                    </Form.Group>
                  </Col>

                  {/* Value */}
                  <Col sm={2}>
                    <Form.Group>
                      <Form.Control type="text" value={value} readOnly />
                    </Form.Group>
                  </Col>

                  {/* Dropdown 1 */}
                  <Col sm={3}>
                    <Form.Group>
                      <Form.Select
                        disabled={!checkedState[key]}
                        value={formValues[key]?.dropdown1 || ""} // ← important
                        onChange={(e) =>
                          handleDropdownChange(key, "dropdown1", e.target.value)
                        }
                      >
                        <option value="">Select a Product metafield</option>
                        <option value="Test 1">Test 1</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  {/* Dropdown 2 */}
                  <Col sm={3}>
                    <Form.Group>
                      <Form.Select
                        disabled={!checkedState[key]}
                        value={formValues[key]?.dropdown2 || ""} // ← important
                        onChange={(e) =>
                          handleDropdownChange(key, "dropdown2", e.target.value)
                        }
                      >
                        <option value="">Select a variant metafield</option>
                        <option value="Test 1">Test 1</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </React.Fragment>
            ))}
        </div>

        <Modal.Footer>
          <button
            type="button"
            onClick={() => setToggle(false)}
            className="modal_cancel_button modal_button model_footer absolute top-2 right-2 text-gray-600 hover:text-black"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={{}}
            className="modal_save_button modal_button model_footer absolute top-2 right-2 text-gray-600 hover:text-black"
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
      </div>
    </>
  );
}

export default MetafieldsPopup;
